import React from 'react'
import { NavLink } from 'react-router-dom'
import { Box } from '@chakra-ui/layout'

import { LinkItemProps } from '../Types/sidebar'
import { Icon } from '@chakra-ui/icon'
import { UserContext } from '../App'
import { useContext } from 'react'
import { Button } from '@chakra-ui/react'

import "./Link.css"

const activeStyle = {
    background: 'white',
    color: 'black'
}

const activeBoxStyle = {
    background: 'white', 
    color: 'teal.500',
    borderRadius: '500px'
}

const Link = ({name, icon}: LinkItemProps) => {

    // @ts-ignore
    const {user, setUser} = useContext(UserContext)

    let to = ""
    if(name === "Home") {
        to = "/"
    }
    if(name === "Settings") {
        to="/settings"
    }
    if(name === "Following") {
        to=`/following/${user.username}`
    }
    if(name === "Login") {
        to='/login'
    }
    if(name === "Liked") {
        to="/liked"
    }

    return (
        <Box className='main-link-container'>    
            <NavLink to={to} className="link-style" style={({ isActive }) => (isActive ? activeStyle : {})}>
                <Box as="span" alignItems="center">
                    <Icon as={icon}></Icon>
                </Box>
                <Box as="span" paddingX="0.75vw" className='navbar-text'>{name}</Box>
            </NavLink>
        </Box>
    )
}

export default Link
